/**
 * Auth0 configuration
 * Uses runtime environment variables from window.ENV
 * Configuration is set per-environment in Kubernetes Helmfiles
 */

import { Auth0ProviderOptions } from '@auth0/auth0-react';
import { getEnv } from './env';

/**
 * Get Auth0 configuration
 * Values are configured per-environment (staging/production) in Helmfiles
 */
export function getAuth0Config(): Auth0ProviderOptions {
  const domain = getEnv('AUTH0_DOMAIN');
  const clientId = getEnv('AUTH0_CLIENT_ID');
  const audience = getEnv('AUTH0_AUDIENCE');
  const scope = getEnv('AUTH0_SCOPE') || 'openid profile email';
  const redirectUri = getEnv('AUTH0_REDIRECT_URI') || window.location.origin;

  if (!domain || !clientId) {
    throw new Error(
      'Auth0 configuration missing. Please set AUTH0_DOMAIN and AUTH0_CLIENT_ID environment variables.'
    );
  }

  console.log('[Auth0Config] Using configuration:', {
    domain,
    audience,
    scope,
    redirectUri,
    clientIdSet: !!clientId
  });

  return {
    domain,
    clientId,
    authorizationParams: {
      redirect_uri: redirectUri,
      audience: audience,
      scope: scope
    },
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true
  };
}

export function isAuth0Configured(): boolean {
  const domain = getEnv('AUTH0_DOMAIN');
  const clientId = getEnv('AUTH0_CLIENT_ID');
  return !!(domain && clientId);
}
